import { render, staticRenderFns } from "./checkbox-secondary.vue?vue&type=template&id=4bf13340&scoped=true&"
import script from "./checkbox-secondary.vue?vue&type=script&lang=js&"
export * from "./checkbox-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf13340",
  null
  
)

export default component.exports